/**
 * @file     CardNavPending.tsx
 * @purpose  Dims the card photo with a spinner while its link navigates, so a
 *           tap on a live-rendered listing shows feedback straight away.
 */
'use client';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useLinkStatus } from 'next/link';
import { useAppTheme } from '@/core/theme/useAppTheme';
import { tint } from '@/design-system/tokens/tint';

export function CardNavPending() {
  const { pending } = useLinkStatus();
  const { theme } = useAppTheme();
  if (!pending) return null;
  return (
    <Box
      aria-hidden
      data-card-nav-pending
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: tint(theme.semanticColors.surfaceCard, 45),
      }}
    >
      <CircularProgress size={28} />
    </Box>
  );
}
